import { render, staticRenderFns } from "./CounselListPage.vue?vue&type=template&id=aadc06dc&"
import script from "./CounselListPage.vue?vue&type=script&lang=js&"
export * from "./CounselListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports